export const formButton = { textAlign: 'right' }
